import React, {useState, useEffect} from 'react'
import {makeStyles} from '@material-ui/core/styles'
import {Box, CssBaseline} from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import {connect} from 'react-redux'
import SwipeTeamsTable from './SwipeTeams/SwipeTeamsTable'
import {dataActions} from '../../../actions'

// using hook API
const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        height: '80vh',
        marginTop: '15px',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '-webkit-fill-available',
    },
}))

const SwiperTeams = props => {
    const classes = useStyles()
    const {
        token,
        swipeteams,
        activedepartment,
        fetchingSwipeTeams,
        deletingSwipeTeams,
        swipeteamDelete,
    } = props

    const [deptId, setDeptId] = useState(activedepartment)

    useEffect(() => {
        setDeptId(activedepartment)
    }, [activedepartment])

    return (
        <>
            <CssBaseline />
            <div className={classes.root}>
                {fetchingSwipeTeams || deletingSwipeTeams ? (
                    <Box
                        className={classes.container}
                        style={{alignItems: 'center', justifyContent: 'center'}}
                    >
                        <CircularProgress
                            style={{
                                color: '#00853e',
                            }}
                            thickness={3}
                        />
                    </Box>
                ) : (
                    <>
                        <Box className={classes.container}>
                            <SwipeTeamsTable
                                token={token}
                                currentdeptId={deptId}
                                swipeteams={swipeteams}
                                deletingSwipeTeams={deletingSwipeTeams}
                                swipeteamDelete={swipeteamDelete}
                            />
                        </Box>
                    </>
                )}
            </div>
        </>
    )
}

function mapStateToProps(state) {
    return {
        token: state.authentication.token,
        swipeteams: state.swipeteamdata.swipeteams,
        activedepartment: state.departmentsdata.activedepartment,
        fetchingSwipeTeams: state.swipeteamdata.fetchingSwipeTeams,
        deletingSwipeTeams: state.swipeteamdata.deletingSwipeTeams,
    }
}

const mapDispatchToProps = {
    swipeteamDelete: (token, payload) =>
        dataActions.swipeteamDeleteRequest(token, payload),
}

export default connect(mapStateToProps, mapDispatchToProps)(SwiperTeams)
